import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import NewsletterStructuredEditor from '../../../components/Admin/Newsletter/NewsletterStructuredEditor.module';
import { ROUTES } from '../../../utils/routes';

function NewsletterStructuredView() {
  const location = useLocation();
  const { type, isNew } = location.state || {};

  if (!type || !isNew) {
    return <Navigate to={ROUTES.ADMIN_NEWSLETTER} />;
  }

  return <NewsletterStructuredEditor />;
}

export default NewsletterStructuredView; 